import * as yup from 'yup';
import { assistanceList, sourceOfApplicationList } from 'contexts/FormProvider';
import { validateDateSchema, validateTextSchema } from 'utils/commonSchema';

yup.setLocale({
  mixed: {
    oneOf: '',
    required: '',
  },
});

const textFieldMax = 4000;
const textFieldMin = 1;

const validationSchema = yup.object().shape({
  dateOfApplication: validateDateSchema({ hasMinDate: false }),

  sourceOfApplication: yup
    .string()
    .nullable()
    .oneOf([...sourceOfApplicationList])
    .required(),

  reason: validateTextSchema({ minLen: textFieldMin, maxLen: textFieldMax, required: true }),

  assistance: yup
    .string()
    .nullable()
    .oneOf([...assistanceList])
    .required(),

  description: validateTextSchema({ minLen: 0, maxLen: textFieldMax, required: false }),
});

export default validationSchema;
